import React from "react";
import JoinUs from "../../common/JoinUs";
import AboutTwoArea from "./AboutTwoArea";
import AchivementTwo from "./AchivementTwo";
import BannerTwo from "./BannerTwo";
import HomeTowTeamArea from "./HomeTowTeamArea";
import HomeTwoLatestBlog from "./HomeTwoLatestBlog";
import HomeTwoSonsor from "./HomeTwoSonsor";
import HomeTwoTestimonial from "./HomeTwoTestimonial";
import ServiceTwoArea from "./Solutions";
import Services from "./Services";
import Deployment from "./Deployment";
import { Helmet } from 'react-helmet'; 

function HomePageTwo() {
  return (
    <>
     {/* Seo  */}
     <Helmet>        
        <title>Genius Fixers | The Best IT support company - Software House</title>
        <link rel='canonical' href='https://www.geniusfixers.com/' />       
        <meta
            name='description'
            content='Genius Fixers | The Best IT support company is a software development and IT company with the best software management system.'
        />
        <meta
            name='keywords'
            content='software house, IT company, software development, software management system'
        />
        </Helmet>
    {/* Seo  */}
      <BannerTwo />
      <ServiceTwoArea />
      <Services/>
      <Deployment/>      
      <HomeTowTeamArea />
      <AboutTwoArea className="mt-4" />
      <AchivementTwo />
   
      {/* <HomeTwoLatestBlog /> */}
      <HomeTwoTestimonial />
      <JoinUs padding="pt-120" />
      <HomeTwoSonsor />
    </>
  );
}

export default HomePageTwo;
